export class Datalayer {
	constructor() {
		this.gtm = 'GTM-N4L3LRL'
	}

	flushDatalayer () {
	  if (window.google_tag_manager) {
	    if (window.google_tag_manager[this.gtm] === undefined) {

	    } else {
	      window.google_tag_manager[this.gtm].dataLayer.reset()
	    }
	  }
	}

	pageView() {
		if (!window.dataLayer) { return false }
		this.flushDatalayer()

		window.dataLayer.push({
		  event: 'pageview',
		  page: {
		    path: window.location.href
		  },
		})
	}

  checkout(step, object, email = '', option = '') {
		if (!window.dataLayer) { return false }
		this.flushDatalayer()

		window.dataLayer.push({
		  event: 'eec.checkout',
		  'ecommerce': {
        'checkout': {
          'actionField': {
            'step': `${step}`,
            'option': `${option}`,
            'email': `${email}`,
            'products': [
              {
                'name': `${object.name}`,
                // 'id': `${object.id}`,
                'brand': `Justdiggit`,
                'price': object.price,
                'variant': `${object.variant}`,
                'category': `${object.category}`
              }
            ]
          }
        }
      }
		})
	}

  purchase(object, lang, purchaseID) {
		if (!window.dataLayer) { return false }
		this.flushDatalayer()
    console.log(purchaseID);

		window.dataLayer.push({
		  event: 'eec.purchase',
		  'ecommerce': {
        'purchase': {
          'actionField': {
            'id': `${purchaseID}`,
            'affiliation': `justdiggit.org/${lang}`,
            'revenue': object.price,
          },
          'products': [{
            'name': `${object.name}`,
            'brand': `Justdiggit`,
            'price': object.price,
            'variant': `${object.variant}`,
            'category': `${object.category}`,
            'quantity': 1
          }]
        }
      }
		})
	}

  toggleMenu(status) {
    if (!window.dataLayer) { return false }
		this.flushDatalayer()
    let menuStatus = (status == 'open') ? 'menu open' : 'menu closed'

    window.dataLayer.push({
		  event: `${menuStatus}`,
		})
  }

  langSwitch(language) {
    if (!window.dataLayer) { return false }
		this.flushDatalayer()

    window.dataLayer.push({
		  event: 'language switch',
      language: language
		})
  }

  newsletter() {
    if (!window.dataLayer) { return false }
		this.flushDatalayer()

    window.dataLayer.push({
		  event: 'newsletter sign up'
		})
  }

  contactForm() {
    if (!window.dataLayer) { return false }
		this.flushDatalayer()

    window.dataLayer.push({
		  event: 'contactform success'
		})
  }

  videoPlay() {
    if (!window.dataLayer) { return false }
		this.flushDatalayer()

    window.dataLayer.push({
		  event: 'video play'
		})
  }
}
